import React from 'react';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_spotless-garage/artifacts/altj3kl2_age.png" 
              alt="One Clean Garage Logo" 
              className="h-16 w-auto"
            />
          </div>
          <nav className="hidden md:flex items-center gap-6">
            <a href="#who-we-are" className="text-slate-600 hover:text-emerald-600 transition-colors text-sm font-medium">
              Who We Are
            </a>
            <a href="#reviews" className="text-slate-600 hover:text-emerald-600 transition-colors text-sm font-medium">
              Reviews
            </a>
            <a href="#quote" className="text-slate-600 hover:text-emerald-600 transition-colors text-sm font-medium">
              Get Quote
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;